import type { Swiper as SwiperInstance } from 'swiper';

/** Next cached routes can preserve React state after Swiper's DOM instance was destroyed. */
export function isLiveSwiper(instance: SwiperInstance | null | undefined): instance is SwiperInstance {
  return Boolean(
    instance && !instance.destroyed && instance.el?.isConnected
    && typeof instance.slideTo === 'function' && typeof instance.on === 'function',
  );
}
